import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Landing from "./landing";
import "./styles/variables.css";
import "./styles/global.css";

// Lucky Doggy — lazy loaded (no afecta bundle de la landing)
const LuckyApp = React.lazy(() => import("./lucky"));

/**
 * App para Landing de Normies
 * Versión simplificada sin navbar crypto
 */
function LandingApp() {
  return (
    <Router>
      <Suspense fallback={<div style={{ background: "#0a0e27", width: "100vw", height: "100vh" }} />}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/fun" element={<LuckyApp />} />
          {/* Ruta para holders - TODO: agregar después */}
          <Route path="/crypto" element={<div>Sección Crypto - Próximamente</div>} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default LandingApp;
